import React from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ClearIcon from "@mui/icons-material/Clear";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { ORDER_STATE } from "../../../../config/constants";

const ACCIONES = [
    { estado: ORDER_STATE.SIN_PREPARAR, etiqueta: "Marcar como sin preparar", Icono: ClearIcon },
    { estado: ORDER_STATE.EN_PREPARACION, etiqueta: "Marcar como en preparación", Icono: EngineeringIcon },
    { estado: ORDER_STATE.PREPARADO, etiqueta: "Marcar como preparado", Icono: CheckIcon },
    { estado: ORDER_STATE.FINALIZADO, etiqueta: "Marcar como finalizado", Icono: DoneAllIcon },
];

const SX_STACK = { alignItems: "center" };
const SX_BOTON = {
    color: "#6c757d",
    "&:hover": { color: "#495057" },
    minWidth: { xs: 40, md: "auto" },
    minHeight: { xs: 40, md: "auto" },
};

/**
 * Botones de cambio de estado de un pedido de venta. Presentacional: la página inyecta onCambiar.
 * Se deshabilitan todos con disabled (cambio en vuelo) y siempre el del estado actual del pedido.
 */
const AccionesEstadoVenta = ({ onCambiar, disabled = false, estadoActual = null }) => (
    <Stack direction="row" spacing={0.5} sx={SX_STACK}>
        {ACCIONES.map(({ estado, etiqueta, Icono }) => (
            <Tooltip key={estado} title={etiqueta}>
                <span>
                    <IconButton
                        size="small"
                        aria-label={etiqueta}
                        disabled={disabled || String(estadoActual ?? "") === estado}
                        onClick={() => onCambiar(estado)}
                        sx={SX_BOTON}
                    >
                        <Icono fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        ))}
    </Stack>
);

export default React.memo(AccionesEstadoVenta);
